import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AuthenticationService } from '../../auth/authentication.service';
import { ApiService } from '../../_services/api.service';
import * as _ from 'lodash';
import { CookieService } from 'ngx-cookie-service';
import * as JsEncryptModule from 'jsencrypt';
import { PublicComponent } from '../public.component';
import { UtilServiceService } from 'src/app/_services/utilService/util-service.service';
import { ProfileFeaturesService } from 'src/app/_services/profile-features.service';
import { UsersService } from 'src/app/_services/admin/users.service';
import { forkJoin, of, Subscription, throwError } from 'rxjs';
import { ErrorUtil } from 'src/app/_utilities/error';
import { NgxSpinnerService } from 'ngx-spinner';

import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { EngLangData,MalayLangData, chineseLangData, deutschLangData, languageOptions, spanishLangData } from "src/app/_models/language.data.model";
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { SettingService } from 'src/app/_services/admin/setting.service';
import { MixpanelService } from 'src/app/_services/mixpanel.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent extends SubscriptionUtil implements OnInit,OnDestroy {
  value:any
  errorMessage!: string;
  login: any = {
    username: '',
    password: '',
    remember: false
  };
  permissions!: { role: any; roles: any[]; };
  submitting: boolean = false;
  hasWrongCredentials: boolean = false;
  loginForm: UntypedFormGroup;
  submitTouched: boolean = false;
  crypt: any = new JsEncryptModule.JSEncrypt();
  fieldTextType!: boolean;
  checkRemember!: boolean;
  currentLang: any = 'English'
 
  @ViewChild('chooseLang') chooseLangEl!: ElementRef;

   langData: any;
  languageList: any;
  subscription: Subscription = new Subscription();
  userProfileInfo: any;
  profileInfo:any;
  licenseInfo: any;
  orgInfo: any;

  constructor(private router: Router,
    private authService: AuthenticationService,
    private apiService: ApiService,
    private perm: ProfileFeaturesService,
    private userService: UsersService,
    private _cookieService: CookieService,
    private spinner: NgxSpinnerService,
    private util : UtilServiceService,
    private errorUtil: ErrorUtil,
    private languageTranslateService: LanguageTranslateService,
    private settingsService : SettingService,
    private mixPanelService: MixpanelService,
  ) {
    super();
    //this.getLanguageData();
      const StrongPasswordRegx: RegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
                                         

    // Initialize the login form with validators
    this.loginForm = new UntypedFormGroup({
      'username': new UntypedFormControl(null, [Validators.required]),
      'password': new UntypedFormControl(null, [Validators.required]),
      'remember': new UntypedFormControl(null)
    });

    // Set the public encryption key for JsEncrypt
    this.crypt.setPublicKey(PublicComponent.publicEncryptionKey);
  }

  ngOnInit() {
    this.spinner.hide();
    if (window.innerWidth < 720) {
          this.router.navigate(['/mobile']);
      }
    var langCode = localStorage.getItem('lang');
    if (langCode == 'my') this.onChangeLanguage('Bahasa Melayu')
    else if (langCode == 'en') this.onChangeLanguage('English')
    else if (langCode == 'zh') this.onChangeLanguage('简体中文')
    else if (langCode == 'de') this.onChangeLanguage('Deutsch')
    else if (langCode == 'es') this.onChangeLanguage('Español')
    else this.onChangeLanguage('English')
   // this.currentLang = "English"
    this.languageList = Object.values(languageOptions);
    if(this._cookieService.get(btoa('remember')) == btoa('true')){
      this.login.username=atob(this._cookieService.get(btoa('username')));
      this.login.password=atob(this._cookieService.get(btoa('password')));
      this.login.remember=atob(this._cookieService.get(btoa('remember')));
    }
    this.checkRemember = this.login.remember ? true:false
  }
 

  /******************************************** Sign In ******************************************/
  signIn(): any {
    this.spinner.show(); // Show the spinner during submission

    this.submitTouched = true; // Mark the form as touched
    this.hasWrongCredentials = false;

    // Validate the form
    if (!this.loginForm.valid) {
      for (var i in this.loginForm.controls) {
        this.loginForm.controls[i].markAsTouched();
      }
      this.spinner.hide();
      return false;
    }

    this.submitting = true;

    // Encrypt the username and password
    var encryptedUsername = this.crypt.encrypt(this.loginForm.value.username);
    var encryptedPassword = this.crypt.encrypt(this.loginForm.value.password);

    // Prepare the login data
    var data = {
      "password": this.login.password,
      "rememberMe": this.checkRemember,
      "username": this.login.username
    };

    this.login.remember = this.checkRemember ? true : false;

    // Store credentials in cookies if "remember me" is checked
    if (this.login.remember) {
      this._cookieService.set(btoa('username'), btoa(this.login.username));
      this._cookieService.set(btoa('password'), btoa(this.login.password));
      this._cookieService.set(btoa('remember'), btoa(this.login.remember));
    } else {
      this._cookieService.deleteAll();
    }

    this.authService.loginAdmin(data).subscribe((res: any)=>{
      console.log("login",res)
        this.hasWrongCredentials = false;
        this.submitting=false;
          if(window.innerWidth < 720){
            setTimeout(() => {
              this.router.navigate(['/mobile']);
              localStorage.clear();
              sessionStorage.clear();
            }, 1000);
          } else {
        
            this.getAccountInfo()
           }
        
      },
      (err) => {
        console.log(err,"err from login response ===>>>")
        //this.errorUtil.setErrorMessage(err);

        var body = err.error;

        if(body.status === 403){
          if(err.error.title){
            this.errorUtil.setErrorMessage(0, err.error.title ,  null, 'error');
          }else{
            this.router.navigate(['/download-app']);
          }
          
         
        }else{
          var data =body.instance+".validationBE."+body.detail;
          console.log("data",data)
          
          this.errorMessage = this.getNestedValue(this.langData, data);
          if(body.detail == 'usernameLeadingSpace'){
             this.errorUtil.setErrorMessage(0, body.title ,  null, 'error');
              
           }else if(body.type=='dynamic-lang-error'){ //dynamic error message
              this.errorUtil.setErrorMessage(0, this.errorMessage ,  null, 'error');
            
            }else if(body.message == 'error.validation'){ //validation error for emapty space
              
              this.errorMessage =this.langData.login.messages.ensureNoBlankSpacesUsername;
              this.errorUtil.setErrorMessage(0, this.errorMessage ,  null, 'error');
            }else {
              this.errorMessage = body.detail;
              this.errorUtil.setErrorMessage(0, this.errorMessage ,  null, 'error');
            }
            this.hasWrongCredentials = true;
        }
        this.spinner.hide();
        // this.alertService.error('Wrong Credentials', 'Incorrect username or password. Please try again.');
        
      
    });
  }

  /******************************************** Validate Form Fields ******************************************/
  validate(field: any) {
    return this.loginForm.controls[field].invalid && (this.loginForm.controls[field].dirty || this.loginForm.controls[field].touched || this.submitTouched);
  }

  /******************************************** Get Account Information ******************************************/
  getAccountInfo() {
    try {
      this.spinner.show()
      this.apiService.getProfile().subscribe(profileResponse=>{
        if(profileResponse){
          localStorage.setItem('lang',profileResponse.langKey)
           this.storeProfileInfo(profileResponse);

        //   this.push(this.languageTranslateService.getTranslateByLanguage(profileResponse.langKey).subscribe((res: any) => {
        //     const words = res.body;
        //    this.languageTranslateService.updateWords(words);
        //    this.languageTranslateService.updateMenu(words);
        //  }));

        }
      }, (err) => {
        // Handle errors in fetching profile information
      });
    } catch (error) {
      console.error(error);
    }
  }

  /******************************************** Store Profile Information ******************************************/
  storeProfileInfo(profileResponse: any) {
    // localStorage.setItem('lang', 'en');  //2024-09-18 Lang Key now getting from profile responce
    localStorage.setItem('profile_id', btoa(profileResponse.id));
    localStorage.setItem('user_name', btoa(profileResponse.firstName));
    if (profileResponse.licenceVM.trial) {
      localStorage.setItem('trialEndDate', profileResponse.licenceVM.validTill);
    }
    localStorage.setItem('qrCodeType', profileResponse.qrCodeType);
    this.util.setCompanyName(profileResponse.companyName);
    var profileInfo = {
      fullName: profileResponse.firstName + ' ' + profileResponse.lastName,
      email: profileResponse.email,
      tenantId: profileResponse.tenantId,
      firstName: profileResponse.firstName,
      tenantCategories: profileResponse.tenantCategories,
      createdDate: profileResponse.licenceVM.createdDate,
      renewalDate: profileResponse.licenceVM.validTill,
      trial: profileResponse.licenceVM.trial,
      login: profileResponse.login,
      billingUser: profileResponse.billingUser,
      dataLoadPerformed: profileResponse.dataLoadPerformed,
      isCustomerPortalEnabled: profileResponse.isCustomerPortalEnabled,
      fxCampaign: profileResponse.fxCampaign
    };

    console.log(profileInfo, 'profileInfo printing in login')
    this.profileInfo = profileInfo;
    localStorage.setItem('profile_info', btoa(JSON.stringify(profileInfo)));
    localStorage.setItem('date_format', profileResponse.dateFormatString);
    this.getAnalyticsBrowser(profileResponse);
    this.getProfileFeature(profileResponse);
  }

  /******************************************** Get Profile Features ******************************************/
  getProfileFeature(profileResponse: any) {
    try {
      this.perm.getProfileFeatures().subscribe(permissionResponse=>{

        if(permissionResponse){
          localStorage.setItem('role_token', btoa(permissionResponse.profile.name));
          this.permissions = {role : permissionResponse.profile.name, roles : []}
          permissionResponse.moduleAccessFeatures.forEach((role:any) => {

            var tempRole = {
              moduleName : role.feature.internalName || role.feature.name,
              read : role.readFeature,
              create : role.createFeature,
              update : role.updateFeature,
              remove : role.deleteFeature
            }
            this.permissions.roles.push(tempRole);
          });

          console.log(permissionResponse);

          permissionResponse.adminSettingsFeatures.forEach((role2: any )=> {
            if(role2.typeValue === 'YES'){
              var tempRole = {
                moduleName : role2.feature.internalName || role2.feature.name,
                read : true,
                create : true,
                update : true,
                remove : true
              }
            } else {
              if(role2.feature.internalName === 'manage_org_detail'){
                var findSetup = _.filter(permissionResponse.moduleAccessFeatures, function(o) { return o.feature.name == 'setup'; })
                if(findSetup.length){
                  var tempRole = {
                    moduleName : role2.feature.internalName,
                    read : false,
                    create : false,
                    update : false,
                    remove : false
                  }
                } else {
                  var tempRole = {
                    moduleName : role2.feature.internalName,
                    read : false,
                    create : false,
                    update : false,
                    remove : false
                  }
                }
              } else {
                var tempRole = {
                  moduleName : role2.feature.internalName,
                  read : false,
                  create : false,
                  update : false,
                  remove : false
                }
              }
            }
            this.permissions.roles.push(tempRole);
          });

          if(permissionResponse.profile.allowAssignTask){
            var tempRole = {
              moduleName : 'allow assign task',
              read : true,
              create : true,
              update : true,
              remove : true
            }
          } else {
            var tempRole = {
              moduleName : 'allow assign task',
              read : false,
              create : false,
              update : false,
              remove : false
            }
          }
          this.permissions.roles.push(tempRole);

          if(permissionResponse.profile.binUser){
            var tempRole = {
              moduleName : 'bin user',
              read : true,
              create : true,
              update : true,
              remove : true
            }
          } else {
            var tempRole = {
              moduleName : 'bin user',
              read : false,
              create : false,
              update : false,
              remove : false
            }
          }

          if(permissionResponse.profile.helpDeskUser){
            var tempRole = {
              moduleName : 'helpdesk user',
              read : true,
              create : true,
              update : true,
              remove : true
            }
          } else {
            var tempRole = {
              moduleName : 'helpdesk user',
              read : false,
              create : false,
              update : false,
              remove : false
            }
          }

          this.permissions.roles.push(tempRole);

          if(permissionResponse.profile.allowViewSalesorderPrice){
            var tempRole = {
              moduleName : 'allow view sales order price',
              read : true,
              create : true,
              update : true,
              remove : true
            }
          } else {
            var tempRole = {
              moduleName : 'allow view sales order price',
              read : false,
              create : false,
              update : false,
              remove : false
            }
          }

          this.permissions.roles.push(tempRole);
          var menuPermissions = {
            defaultTenantCategory : permissionResponse.profile.defaultTenantCategory.toLowerCase(),
            sales : permissionResponse.profile.sales,
            service : permissionResponse.profile.service,
            fleet : permissionResponse.profile.fleet
          }
          ////
          localStorage.setItem('menuPermissions', JSON.stringify(menuPermissions));
          localStorage.setItem('permissions', JSON.stringify(this.permissions));
          localStorage.setItem('allowAssignShift', permissionResponse.profile.allowAssignShift);
          localStorage.setItem('allowFilterByHierarchy', permissionResponse.profile.allowFilterByHierarchy);
          this.getUserProfile(permissionResponse, profileResponse)
        }
      });
    } catch (error) {
      console.error(error);
    }
  }

  /******************************************** Store Permissions and Navigate ******************************************/
  storePermissions(permissionResponse: any) {
    localStorage.setItem('role_token', btoa(permissionResponse.profile.name));
    this.permissions = {role : permissionResponse.profile.name, roles : []}
    permissionResponse.moduleAccessFeatures.forEach((role:any) => {

      var tempRole = {
        moduleName : role.feature.internalName || role.feature.name,
        read : role.readFeature,
        create : role.createFeature,
        update : role.updateFeature,
        remove : role.deleteFeature
      }
      this.permissions.roles.push(tempRole);
    });

    console.log(permissionResponse);

    permissionResponse.adminSettingsFeatures.forEach((role2: any )=> {
      if(role2.typeValue === 'YES'){
        var tempRole = {
          moduleName : role2.feature.internalName || role2.feature.name,
          read : true,
          create : true,
          update : true,
          remove : true
        }
      } else {
        if(role2.feature.internalName === 'manage_org_detail'){
          var findSetup = _.filter(permissionResponse.moduleAccessFeatures, function(o) { return o.feature.name == 'setup'; })
          if(findSetup.length){
            var tempRole = {
              moduleName : role2.feature.internalName,
              read : false,
              create : false,
              update : false,
              remove : false
            }
          } else {
            var tempRole = {
              moduleName : role2.feature.internalName,
              read : false,
              create : false,
              update : false,
              remove : false
            }
          }
        } else {
          var tempRole = {
            moduleName : role2.feature.internalName,
            read : false,
            create : false,
            update : false,
            remove : false
          }
        }
      }
      this.permissions.roles.push(tempRole);
    });

    if(permissionResponse.profile.allowAssignTask){
      var tempRole = {
        moduleName : 'allow assign task',
        read : true,
        create : true,
        update : true,
        remove : true
      }
    } else {
      var tempRole = {
        moduleName : 'allow assign task',
        read : false,
        create : false,
        update : false,
        remove : false
      }
    }
    this.permissions.roles.push(tempRole);

    if(permissionResponse.profile.binUser){
      var tempRole = {
        moduleName : 'bin user',
        read : true,
        create : true,
        update : true,
        remove : true
      }
    } else {
      var tempRole = {
        moduleName : 'bin user',
        read : false,
        create : false,
        update : false,
        remove : false
      }
    }

    if(permissionResponse.profile.helpDeskUser){
      var tempRole = {
        moduleName : 'helpdesk user',
        read : true,
        create : true,
        update : true,
        remove : true
      }
    } else {
      var tempRole = {
        moduleName : 'helpdesk user',
        read : false,
        create : false,
        update : false,
        remove : false
      }
    }

    this.permissions.roles.push(tempRole);

    if(permissionResponse.profile.allowViewSalesorderPrice){
      var tempRole = {
        moduleName : 'allow view sales order price',
        read : true,
        create : true,
        update : true,
        remove : true
      }
    } else {
      var tempRole = {
        moduleName : 'allow view sales order price',
        read : false,
        create : false,
        update : false,
        remove : false
      }
    }

    this.permissions.roles.push(tempRole);
    var menuPermissions = {
      defaultTenantCategory : permissionResponse.profile.defaultTenantCategory.toLowerCase(),
      sales : permissionResponse.profile.sales,
      service : permissionResponse.profile.service,
      fleet : permissionResponse.profile.fleet
    }
    ////
    localStorage.setItem('menuPermissions', JSON.stringify(menuPermissions));
    localStorage.setItem('permissions', JSON.stringify(this.permissions));
    localStorage.setItem('allowAssignShift', permissionResponse.profile.allowAssignShift);
    localStorage.setItem('allowFilterByHierarchy', permissionResponse.profile.allowFilterByHierarchy);
    //this.getUserProfile(permissionResponse, profileResponse)
  }

  /******************************************** Add Additional Profile Permissions ******************************************/
  addAdditionalPermissions(permissionResponse: any) {
    permissionResponse.adminSettingsFeatures.forEach((role2: any )=> {
      if(role2.typeValue === 'YES'){
        var tempRole = {
          moduleName : role2.feature.internalName || role2.feature.name,
          read : true,
          create : true,
          update : true,
          remove : true
        }
      } else {
        if(role2.feature.internalName === 'manage_org_detail'){
          var findSetup = _.filter(permissionResponse.moduleAccessFeatures, function(o) { return o.feature.name == 'setup'; })
          console.log(findSetup)
          
          if(findSetup.length){
            
            var tempRole = {
              moduleName : role2.feature.internalName,
              read : false,
              create : false,
              update : false,
              remove : false
            }
          } else {
            var tempRole = {
              moduleName : role2.feature.internalName,
              read : false,
              create : false,
              update : false,
              remove : false
            }
          }
        } else {
          var tempRole = {
            moduleName : role2.feature.internalName,
            read : false,
            create : false,
            update : false,
            remove : false
          }
        }
      }
      this.permissions.roles.push(tempRole);
    });

    if(permissionResponse.profile.allowAssignTask){
      var tempRole = {
        moduleName : 'allow assign task',
        read : true,
        create : true,
        update : true,
        remove : true
      }
    } else {
      var tempRole = {
        moduleName : 'allow assign task',
        read : false,
        create : false,
        update : false,
        remove : false
      }
    }
    this.permissions.roles.push(tempRole);

    if(permissionResponse.profile.binUser){
      var tempRole = {
        moduleName : 'bin user',
        read : true,
        create : true,
        update : true,
        remove : true
      }
    } else {
      var tempRole = {
        moduleName : 'bin user',
        read : false,
        create : false,
        update : false,
        remove : false
      }
    }

    if(permissionResponse.profile.helpDeskUser){
      var tempRole = {
        moduleName : 'helpdesk user',
        read : true,
        create : true,
        update : true,
        remove : true
      }
    } else {
      var tempRole = {
        moduleName : 'helpdesk user',
        read : false,
        create : false,
        update : false,
        remove : false
      }
    }

    this.permissions.roles.push(tempRole);

    if(permissionResponse.profile.allowViewSalesorderPrice){
      var tempRole = {
        moduleName : 'allow view sales order price',
        read : true,
        create : true,
        update : true,
        remove : true
      }
    } else {
      var tempRole = {
        moduleName : 'allow view sales order price',
        read : false,
        create : false,
        update : false,
        remove : false
      }
    }
    this.permissions.roles.push(tempRole);
  }

  /******************************************** Get User Profile ******************************************/
  getUserProfile(permissionResponse: any, profileResponse: any) {
    this.userService.getUserProfile(this.authService.getUserId()).subscribe((userProfileResponse: any) => {
      if (userProfileResponse) {
        this.userProfileInfo = userProfileResponse;
        this.storeUserProfile(userProfileResponse); // Store user profile details in local storage
        this.loadTenantInfo(profileResponse, permissionResponse, userProfileResponse); // Load tenant information
      }
    }, (err) => {
      // Handle errors in fetching user profile
    });
  }

  /******************************************** Store User Profile ******************************************/
  storeUserProfile(userProfileResponse: any) {
    var homeAddress = '';
    var officeAddress = '';

    // Construct home and office addresses
    for (let key in userProfileResponse) {
      if (key.startsWith('home') && userProfileResponse[key]) {
        if(key != 'homePlaceId' && key != 'homeLatitude' && key != 'homeLongitude'){
        homeAddress +=  userProfileResponse[key] + ', ';
        }
      }
      if (key.startsWith('office') && userProfileResponse[key]) {
        if(key != 'officePlaceId' && key != 'officeLatitude' && key != 'officeLongitude'){
        officeAddress += userProfileResponse[key] + ', ';
        }
      }
    }

    // Store the addresses in local storage
    if (homeAddress) {
      var homeAdd = { address: homeAddress, placeId: userProfileResponse.homePlaceId, lat: userProfileResponse.homeLatitude, lng: userProfileResponse.homeLongitude };
      localStorage.setItem('home_address', JSON.stringify(homeAdd));
    }
    if (officeAddress) {
      var officeAdd = { address: officeAddress, placeId: userProfileResponse.officePlaceId, lat: userProfileResponse.officeLatitude, lng: userProfileResponse.officeLongitude };
      localStorage.setItem('office_address', JSON.stringify(officeAdd));
    }

    localStorage.setItem('buffer', JSON.stringify({ start: userProfileResponse.startBuffer, end: userProfileResponse.endBuffer }));
    localStorage.setItem('timezone', userProfileResponse.timezone);
    localStorage.setItem('profileName', userProfileResponse.profileName);
    localStorage.setItem('profileId', userProfileResponse.profileId);
    localStorage.setItem('shiftWorking', userProfileResponse.shiftWorking);
  }

  /******************************************** Navigate Based on Profile ******************************************/
  navigateBasedOnProfile(profileResponse: any, permissionResponse: any) {
    setTimeout(() => {
      if (profileResponse.firstTimeLogin) {
        this.router.navigate(['/profile-info']);
      } else {
        // if (permissionResponse.profile.defaultTenantCategory.toLowerCase() === 'fleet') {
        //   this.router.navigate(['/dashboard/homeFleet']);
        // } else {
          this.router.navigate(['/dashboard/jobOrders/all']);
       // }
      }
      this.spinner.hide();
    }, 1000);
  }

 /************************************* Get Tanant Addon Feature List **********************/
  loadTenantInfo(profileResponse: any, permissionResponse: any, userProfileResponse: any){
    forkJoin(
            this.settingsService.getTenantList(),
            this.settingsService.getTenantPackageList(),
            this.settingsService.getSetupLicenseDetals(),
            this.settingsService.getOrgSettings(1),
           this.settingsService.getTenantPackageListToHide()).subscribe(([res, respackage, licenseInfo, orgInfo, hiddenFeatures]) => {

      
      var addonFeatureList: any[] =[]
      var addonPackageList: any[] =[]

       this.licenseInfo = licenseInfo.body;
       if(this.licenseInfo.packageCode) {
        localStorage.setItem('packageCode',this.licenseInfo.packageCode);
        this.GetMixPanelEvents(profileResponse,profileResponse.id);
        console.log("permissionResponse", profileResponse)
       } else {
         localStorage.setItem('packageCode','Old');
           }
      
       localStorage.setItem('licenseInfo', JSON.stringify(this.licenseInfo));
      console.log("Res1112233", this.licenseInfo)
    

      if (Array.isArray(res.body) && res.body.length > 0) {
        const addonFeatureList = res.body.map((element: any) => element.addonFeature);
        // Store the array in local storage
        localStorage.setItem('addonFeatureList', JSON.stringify(addonFeatureList));
      }else{
        res.body.push('ONBOARD')
      }
       if (Array.isArray(respackage.body) && respackage.body.length > 0 && this.licenseInfo.packageCode) {
        const addonPackageList = respackage.body.map((element: any) => element.featureCode);
        // Store the array in local storage
        localStorage.setItem('addonPackageList', JSON.stringify(addonPackageList));
      }else{
        localStorage.setItem('addonPackageList', JSON.stringify([]));
      }

      if (Array.isArray(hiddenFeatures.body) && hiddenFeatures.body.length > 0 && this.licenseInfo.packageCode) {
        const addonPackageList = hiddenFeatures.body
          .filter((element: any) => element.hidden === true)
          .map((element: any) => element.featureCode);
        // Store the array in local storage
        localStorage.setItem('addonPackageListToHide', JSON.stringify(addonPackageList));
      }else{
        localStorage.setItem('addonPackageListToHide', JSON.stringify([]));
      }

     
       var addonFeatureMS: any[] = [];
       var addonFeatureONBOARD: any[] = [];
       var addonDASHBOARDASSETS: any[] = [];
       if (res.body.length > 0) {
        
        addonFeatureMS = res.body.filter((o: any) => {   return o.addonFeature == 'MACHINE_SPECIALIST';  });
        addonFeatureONBOARD = res.body.filter((o: any) => { return o.addonFeature == 'ONBOARD';   });
        addonDASHBOARDASSETS = res.body.filter((o: any) => { return o.addonFeature == 'DASHBOARD_ASSETS';   });
      }

      this.orgInfo = orgInfo;
      
      console.log(addonFeatureMS, '===>>>',res.body)
      let currentPackage: any = localStorage.getItem('packageCode');

       setTimeout(() => {
        //check if the user has completed setting up company and packages
          //check if it is billingUser. If yes, check for license expired flag
          if (userProfileResponse.billingUser == true && profileResponse.tenantStatus == 'EXPIRED'){
            //redirect the user to license billing page
            localStorage.setItem('expiredUser', 'true');
            this.router.navigate(['/dashboard/setup/licenseBilling']);
          }else if(addonFeatureONBOARD[0]?.addonFeature == 'ONBOARD' ){
              //If the user's addon is ONBOARD, redirect to onboarding page
              localStorage.setItem('doNotShowOnBoard', this.userProfileInfo.doNotShowOnBoard);
              let count_completed_steps: number = 0; //total number of steps completed

              let completedStepsObj: any = {};
              for (var i=0; i<4; i++){
                if ( profileResponse['onBoardingStep'+(i+1)] === true){
                  count_completed_steps++;
                  completedStepsObj['onBoardingStep'+(i+1)] = true;
                }
                else{
                  completedStepsObj['onBoardingStep'+(i+1)] = false;
                }
              }

              //let current_step: number = this.userProfileInfo?.onBoardingStepsAt ? parseInt(this.userProfileInfo?.onBoardingStepsAt) : 0;
              let current_step: number = count_completed_steps;

              let completed_percent: any = 100 * (current_step/4);
              localStorage.setItem('completedStepsObj', JSON.stringify(completedStepsObj))
              localStorage.setItem('onBoardingStepsAt', current_step.toString());
              localStorage.setItem('onBoardStepCompletionPercent', completed_percent);

              // let profileName: string = localStorage.getItem("profileName");
              // let allowedProfiles: string[] = ['Admin', 'Manager'];
              if (profileResponse.dataLoadPerformed === true && addonDASHBOARDASSETS[0]?.addonFeature != 'DASHBOARD_ASSETS') {
                this.router.navigate(['/dashboard/jobOrders/all']);
              }else if (profileResponse.dataLoadPerformed === true && addonDASHBOARDASSETS[0]?.addonFeature == 'DASHBOARD_ASSETS') {
                this.router.navigate(['/dashboard/cmms']);
              }else{
                //if the user hasn't completed setting up company and packages, and trying to login
                this.router.navigate(['/company-setup']);
              }
          }else if(currentPackage == 'Old'){
            //  if (profileResponse.dataLoadPerformed === true || currentPackage == 'Old'){
                if (addonFeatureMS[0]?.addonFeature== 'MACHINE_SPECIALIST') {
                  localStorage.setItem('msUrl', '1');
                  this.router.navigate(['/dashboard/attendance/all']);
                }else{
                  // if user has addon feature MAGNUM or CHUBB, redirect to home page
                var addonFeatureMagnum = res.body.filter((o: any) => {   return o.addonFeature == 'MAGNUM';  });
                var addonFeatureChubb = res.body.filter((o: any) => { return o.addonFeature == 'CHUBB';   });

                  if(addonFeatureMagnum[0]?.addonFeature == 'MAGNUM' || addonFeatureChubb[0]?.addonFeature == 'CHUBB'){
                    this.router.navigate(['/dashboard/home']);
                  }else if(addonDASHBOARDASSETS[0]?.addonFeature == 'DASHBOARD_ASSETS'){
                    this.router.navigate(['/dashboard/cmms']);
                  } else {
                    this.router.navigate(['/dashboard/jobOrders/all'])
                  }
                    // this.router.navigate(['/dashboard/jobOrders/all']); // If the user is not first time login, redirect to job orders page
                }
              // }
              // else{
              //   //if the user hasn't completed setting up company and packages, and trying to login
              //   this.router.navigate(['/company-setup']);
              // }
          }
          
        this.spinner.hide();
      }, 1000);
    });
  }

  /******************************************** Handle Login Errors ******************************************/
  handleError(err: any) {
    var body = err.error;
    if (body.status === 403) {
      if (err.error.title) {
        this.errorUtil.setErrorMessage(0, err.error.title, null, 'error');
      } else {
        this.router.navigate(['/download-app']);
      }
    } else {
      this.processLoginError(body);
    }
    this.spinner.hide();
  }

  /******************************************** Process Login Errors ******************************************/
  processLoginError(body: any) {
    if (body.detail === 'Bad credentials') {
      this.errorMessage = "Invalid credentials. Please try again";
    } else if (body.message === 'error.validation') {
      this.errorMessage = "Please ensure you have no blank spaces before or after your username";
    } else {
      this.errorMessage = body.detail;
    }
    this.errorUtil.setErrorMessage(0, this.errorMessage, null, 'error');
    this.hasWrongCredentials = true;
  }

  /******************************************** Toggle Password Visibility ******************************************/
  showPassword() {
    this.fieldTextType = !this.fieldTextType;
  }
  
  
  push(obs:any) {
    super.push(obs);
  }

  onChangeLanguage(landKey: any) {
    console.log(landKey)
    
    if (landKey.value == 'English' || landKey == 'English') {
      this.currentLang = languageOptions.english
      this.langData = EngLangData
      this.chooseLangEl?.nativeElement.classList.remove('show');
      localStorage.setItem('lang', 'en')
    }
    if (landKey.value == 'Bahasa Melayu' || landKey == 'Bahasa Melayu') {
      this.currentLang = languageOptions.malay
      this.langData = MalayLangData
      this.chooseLangEl?.nativeElement.classList.remove('show');
      localStorage.setItem('lang', 'my')

    }
    if (landKey.value == '简体中文' || landKey == '简体中文') {
      this.currentLang = languageOptions.chinese
      this.langData = chineseLangData
      this.chooseLangEl?.nativeElement.classList.remove('show');
      localStorage.setItem('lang', 'zh')

    }
    if (landKey.value == "Deutsch" || landKey == "Deutsch") {
      this.currentLang = languageOptions.deutsch;
      this.langData = deutschLangData;
      this.chooseLangEl?.nativeElement.classList.remove("show");
      localStorage.setItem("lang", "de");
    }
    if (landKey.value == "Español" || landKey == "Español") {
      this.currentLang = languageOptions.spanish;
      this.langData = spanishLangData;
      this.chooseLangEl?.nativeElement.classList.remove("show");
      localStorage.setItem("lang", "es");
    }
    console.log(this.langData)
  }
ngOnDestroy() {
 super.ngOnDestroy();
 this.subscription.unsubscribe();
  
}

 getNestedValue(obj: any, path: string): any {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj);
}

GetMixPanelEvents(profileInfo: any, userId: any){
  this.mixPanelService.init(); // Initialize Mixpanel
   
   //this.mixPanelService.identify(userId); // Identify the user with Mixpanel
    // Use a unique identifier for distinct ID
  const distinctId = profileInfo.login;
console.log("distinctId", distinctId)

  this.mixPanelService.identify(distinctId); // Identify the user with Mixpanel

    this.mixPanelService.setPeople({
      '$name': profileInfo.firstName+ ' ' + profileInfo.lastName,
      '$email': profileInfo.login,
      '$distinct_id': profileInfo.login,
      '$fxCampaign': profileInfo.fxCampaign
    }); // Set user properties in Mixpanel
}
getAnalyticsBrowser(profileInfo: any) {
  //Mixpanel Event Tracking
  if(localStorage.getItem('packageCode') != null && localStorage.getItem('packageCode') != 'Old'){
    this.mixPanelService.track('w_user_login', { propertyName: 'w_user_login', method: 'button_click'});
  }
}

 openItemToNewTab() {
      let url = environment.fieldexPortalUrl+"?plan=Lite&bill=Monthly";
      window.open(url, "_blank", "noreferrer");

  }
  
}